import { render, staticRenderFns } from "./PersonalInformationForm.vue?vue&type=template&id=49722246"
import script from "./PersonalInformationForm.vue?vue&type=script&lang=js"
export * from "./PersonalInformationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports